<template>
  <section>
    <v-row class="mt-10">
      <v-col cols="12">
        <v-row justify="end" class="align-center">
          <v-col cols="auto">
            <v-btn
              @click="openDeleteTemp"
              class="accent shadow-4 px-8"
              color="info"
              rounded
            >
              Borrar
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="tableHeaders"
          :items="tableData"
          :loading="isLoading"
          :options.sync="tableOptions"
          :server-items-length="totalItems"
          :footer-props="{
            'items-per-page-options': [15, 30, 50, 100],
          }"
          show-expand
          single-expand
        >
          <template v-slot:[`item.action`]="{ item }">
            <v-btn
              small
              rounded
              color="primary"
              class="my-2"
              @click.stop="sendTypification(true, item.id)"
            >
              Tipificar
            </v-btn>
            <v-btn
              small
              rounded
              color="primary"
              class="mb-2"
              @click.stop="sendTypification(false, item.id)"
            >
              No Tipificar
            </v-btn>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at) }}
          </template>
          <template v-slot:[`item.type`]="{ item }">
            {{ item.type === "E" ? "Entrada" : "Salida" }}
          </template>

          <template v-slot:expanded-item="{ item }">
            <td colspan="9">
              <v-row v-if="item.contact" class="pl-15 ml-10 pt-8 pb-5">
                <v-col cols="4" class="py-0">
                  <p class="info--text">
                    Nombre:
                    <span class="text--primary">{{ item.contact.name }}</span>
                  </p>
                </v-col>
                <v-col cols="4" class="py-0">
                  <p class="info--text">
                    Apellido:
                    <span class="text--primary">{{
                      item.contact.lastNAme
                    }}</span>
                  </p>
                </v-col>
                <v-col cols="4" class="py-0">
                  <p class="info--text">
                    Email:
                    <span class="text--primary">
                      <a
                        class="text--primary"
                        :href="`mailto:${item.contact.email}`"
                      >
                        {{ item.contact.email }}
                      </a>
                    </span>
                  </p>
                </v-col>
                <v-col cols="4" class="py-0">
                  <p class="info--text">
                    Bussiness:
                    <span class="text--primary">{{
                      item.contact.business
                    }}</span>
                  </p>
                </v-col>
                <v-col cols="4" class="py-0">
                  <p class="info--text">
                    Comentarios:
                    <span class="text--primary">{{
                      item.contact.comments
                    }}</span>
                  </p>
                </v-col>
              </v-row>
              <p v-else class="pl-15 ml-10">
                Datos de contacto no disponibles.
              </p>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <delete-temp-dialog
      v-if="isOpenDeleteTemp"
      :active="isOpenDeleteTemp"
      :baseUrl="baseUrl"
      :options="options"
      @dialog:close="isOpenDeleteTemp = false"
    ></delete-temp-dialog>
  </section>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DeleteTempDialog from "@/components/Typifications/DeleteTempDialog";
export default {
  components: {
    DeleteTempDialog,
  },
  data() {
    return {
      isLoading: true,
      isOpenDeleteTemp: false,
      baseUrl: `${process.env.VUE_APP_URL_BASE}:8096`,
      options: {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },

      totalItems: 0,
      tableOptions: {
        page: 1,
        itemsPerPage: 15,
      },
      tableHeaders: [
        {
          text: "Extension",
          align: "left",
          value: "extension",
          width: "10%",
        },
        {
          text: "Numero",
          align: "left",
          value: "call_number",
          width: "10%",
        },
        {
          text: "Tipo",
          align: "left",
          value: "type",
          width: "10%",
        },
        {
          text: "Fecha",
          align: "left",
          value: "created_at",
          width: "15%",
        },
        {
          text: "Variable 1",
          align: "left",
          value: "variable_1",
          width: "10%",
        },
        {
          text: "Variable 2",
          align: "left",
          value: "variable_2",
          width: "10%",
        },
        {
          text: "Variable 3",
          align: "left",
          value: "variable_3",
          width: "10%",
        },
        {
          text: "Acciones",
          value: "action",
          width: "15%",
          align: "center",
          sortable: false,
        },
      ],
      tableData: [],
    };
  },

  created() {
    this.getInfo();
  },

  watch: {
    options: {
      handler() {
        this.getInfo();
      },
      deep: true,
    },
  },

  methods: {
    async getInfo() {
      this.isLoading = true;
      const page = this.options.page || 1;
      const itemPerPage = this.options.itemsPerPage || 15;
      this.isLoading = true;
      try {
        const { data } = await axios.get(
          `${this.baseUrl}/api/temporary_table/index_client`,
          {
            ...this.options,
            params: { page, itemPerPage },
          }
        );
        this.totalItems = data.total;
        this.tableData = data.data;
        // console.log("data", data);
      } catch (err) {
        console.log("err", err);
      }
      this.isLoading = false;
    },

    openDeleteTemp() {
      this.isOpenDeleteTemp = true;
    },

    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm");
    },
  },
};
</script>
